(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/first-page/components/external-suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/first-page/components/external-suspension.js');
'use strict';

const {
  ReactButton: Button
} = svs.ui;
const {
  ReactIcon: Icon
} = svs.ui;
const ExternalSuspension = () => {
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  return React.createElement(React.Fragment, null, React.createElement("h2", {
    className: "h1 align-left"
  }, "Nationell avst\xE4ngning"), React.createElement("p", {
    className: "align-left"
  }, "Du kan st\xE4nga av dig f\xF6r allt spel hos samtliga licensierade spelbolag i Sverige p\xE5 spelpaus.se (Spelinspektionen). Observera att du inte kan st\xE4nga av dig fr\xE5n ett enskilt spel eller spelbolag. T\xE4nk p\xE5 att p\xE5g\xE5ende prenumerationer p\xE5verkas vid avst\xE4ngning. L\xE4s mer p\xE5 spelpaus.se"), React.createElement("a", {
    className: "u-text-decoration-none",
    href: isLoggedIn ? '/logga-ut?afterAction=narspelpaus' : 'http://www.spelpaus.se?scos=true'
  }, React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    iconPosition: "right",
    inverted: true,
    size: 300
  }, "Till Spelpaus.se", React.createElement(Icon, {
    icon: "external_link",
    size: "100"
  }))), React.createElement("p", {
    className: "align-left margin-top-1"
  }, "N\xE4r du trycker p\xE5 knappen kommer du att skickas till spelpaus.se"));
};
svs.spelpaus.pages.firstPage.components.ExternalSuspension = ExternalSuspension;

 })(window);